export enum FlagState {
  Disabled,
  Enabled,
  Unknown
}

export class FeatureFlag {
  private state: FlagState
  readonly name: string

  constructor(name: string, state: FlagState = FlagState.Unknown) {
    this.name = name
    this.state = state
  }

  getCurrentState = () => this.state

  isEnabled = (): boolean => this.state === FlagState.Enabled
}

export interface FeatureFlagReadModel {
  getByName: (flagName: string) => FeatureFlag
}
